<template>
  <div class="app-container">
    <!-- 代理配置搜索部分 -->
    <div class="search-container" style="display: flex; margin-bottom: 20px;">
      <div>
        <el-input v-model="searchForm.name" placeholder="搜索代理名称" class="search-input" clearable></el-input>
      </div>
      <div style="margin-left: 10px;">
        <el-input v-model="searchForm.ip" placeholder="搜索IP地址" class="search-input" clearable></el-input>
      </div>
      <div style="margin-left: 10px;">
        <el-select v-model="searchForm.status" placeholder="状态" clearable>
          <el-option label="全部" :value="null"></el-option>
          <el-option label="启用" :value="true"></el-option>
          <el-option label="禁用" :value="false"></el-option>
        </el-select>
      </div>
      <div style="margin-left: 10px;">
        <el-button type="primary" @click="fetchProxyConfigs">搜索</el-button>
      </div>
      <div style="margin-left: 10px;">
        <el-button type="success" @click="resetSearch">重置</el-button>
      </div>
      <div style="margin-left: auto;">
        <el-button type="primary" @click="handleAdd">添加代理</el-button>
      </div>
    </div>

    <!-- 代理配置表格展示 -->
    <el-table :data="proxyConfigs" style="width: 100%">
      <el-table-column property="id" label="ID" width="80"></el-table-column>
<!--      <el-table-column property="name" label="代理名称" width="150"></el-table-column>-->
      <el-table-column property="ip" label="IP地址" width="150"></el-table-column>
      <el-table-column property="port" label="端口" width="100">
<!--      <el-table-column property="username" label="用户名" width="120"></el-table-column>-->
<!--      <el-table-column property="password" label="密钥" width="120">-->
        <template v-slot:default="scope">
          <span>{{ scope.row.password ? '******' : '' }}</span>
        </template>
      </el-table-column>
      <el-table-column property="status" label="状态" width="100">
        <template v-slot:default="scope">
          <el-tag :type="scope.row.status ? 'success' : 'danger'">
            {{ scope.row.status ? '启用' : '禁用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column property="createdAt" label="创建时间" width="180">
        <template v-slot:default="scope">
          {{ formatDate(scope.row.createdAt) }}
        </template>
      </el-table-column>
      <el-table-column property="updatedAt" label="更新时间" width="180">
        <template v-slot:default="scope">
          {{ formatDate(scope.row.updatedAt) }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="250">
        <template v-slot:default="scope">
          <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button type="text" @click="handleToggleStatus(scope.row.id)">
            {{ scope.row.status ? '禁用' : '启用' }}
          </el-button>
          <el-button type="text" style="color: red" @click="handleDelete(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="totalProxyConfigs">
    </el-pagination>

    <!-- 编辑/添加代理配置对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="40%">
      <el-form :model="currentProxy" label-width="120px" :rules="rules" ref="proxyForm">
<!--        <el-form-item label="代理名称" prop="name">-->
<!--          <el-input v-model="currentProxy.name"></el-input>-->
<!--        </el-form-item>-->
        <el-form-item label="IP地址" prop="ip">
          <el-input v-model="currentProxy.ip"></el-input>
        </el-form-item>
<!--        <el-form-item label="端口" prop="port">-->
<!--          <el-input v-model.number="currentProxy.port" type="number"></el-input>-->
<!--        </el-form-item>-->
<!--        <el-form-item label="用户名">-->
<!--          <el-input v-model="currentProxy.username"></el-input>-->
<!--        </el-form-item>-->
<!--        <el-form-item label="密码">-->
<!--          <el-input v-model="currentProxy.password" type="password" show-password></el-input>-->
<!--        </el-form-item>-->
        <el-form-item label="状态">
          <el-switch v-model="currentProxy.status"></el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      searchForm: {
        name: '',
        ip: '',
        status: null
      },
      proxyConfigs: [],
      totalProxyConfigs: 0,
      currentPage: 1,
      pageSize: 10,
      dialogVisible: false,
      dialogTitle: '',
      isEdit: false,
      currentProxy: {
        name: '',
        ip: '',
        port: null,
        username: '',
        password: '',
        status: true
      },
      rules: {
        name: [
          { required: true, message: '请输入代理名称', trigger: 'blur' }
        ],
        ip: [
          { required: true, message: '请输入IP地址', trigger: 'blur' }
        ],
        port: [
          { required: true, message: '请输入端口', trigger: 'blur' },
          { type: 'number', message: '端口必须为数字', trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    formatDate(timestamp) {
      if (!timestamp) return '';
      const date = new Date(timestamp);
      return date.toLocaleString();
    },

    async fetchProxyConfigs() {
      try {
        const response = await axios.get('/api/admin/proxy/page', {
          params: {
            current: this.currentPage,
            size: this.pageSize,
            name: this.searchForm.name || undefined,
            ip: this.searchForm.ip || undefined,
            status: this.searchForm.status
          },
          headers: {
            'token': this.$cookies.get('token')
          }
        });

        if (response.data.code === 200) {
          this.proxyConfigs = response.data.data;
          this.totalProxyConfigs = response.data.total;
          this.currentPage = response.data.current;
          this.pageSize = response.data.size;
        } else {
          this.$message.error('获取代理配置列表失败: ' + response.data.msg);
        }
      } catch (error) {
        this.$message.error('获取代理配置列表出错: ' + error.message);
      }
    },

    resetSearch() {
      this.searchForm = {
        name: '',
        ip: '',
        status: null
      };
      this.currentPage = 1;
      this.fetchProxyConfigs();
    },

    handleAdd() {
      this.isEdit = false;
      this.dialogTitle = '添加代理配置';
      this.currentProxy = {
        name: '',
        ip: '',
        port: null,
        username: '',
        password: '',
        status: true
      };
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.proxyForm && this.$refs.proxyForm.clearValidate();
      });
    },

    handleEdit(proxy) {
      this.isEdit = true;
      this.dialogTitle = '编辑代理配置';
      this.currentProxy = { ...proxy };
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.proxyForm && this.$refs.proxyForm.clearValidate();
      });
    },

    submitForm() {
      this.$refs.proxyForm.validate(async (valid) => {
        if (valid) {
          try {
            let response;
            if (this.isEdit) {
              response = await axios.put('/api/admin/proxy', this.currentProxy, {
                headers: {
                  'token': this.$cookies.get('token')
                }
              });
            } else {
              response = await axios.post('/api/admin/proxy', this.currentProxy, {
                headers: {
                  'token': this.$cookies.get('token')
                }
              });
            }

            if (response.data.code === 200) {
              this.$message.success(this.isEdit ? '代理配置更新成功' : '代理配置添加成功');
              this.dialogVisible = false;
              this.fetchProxyConfigs();
            } else {
              this.$message.error((this.isEdit ? '代理配置更新失败: ' : '代理配置添加失败: ') + response.data.msg);
            }
          } catch (error) {
            this.$message.error((this.isEdit ? '代理配置更新出错: ' : '代理配置添加出错: ') + error.message);
          }
        } else {
          return false;
        }
      });
    },

    async handleToggleStatus(id) {
      try {
        const response = await axios.put(`/api/admin/proxy/toggle-status/${id}`, null, {
          headers: {
            'token': this.$cookies.get('token')
          }
        });

        if (response.data.code === 200) {
          this.$message.success('代理状态切换成功');
          this.fetchProxyConfigs();
        } else {
          this.$message.error('代理状态切换失败: ' + response.data.msg);
        }
      } catch (error) {
        this.$message.error('代理状态切换出错: ' + error.message);
      }
    },

    async handleDelete(id) {
      this.$confirm('确定要删除这个代理配置吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const response = await axios.delete(`/api/admin/proxy/${id}`, {
            headers: {
              'token': this.$cookies.get('token')
            }
          });

          if (response.data.code === 200) {
            this.$message.success('代理配置删除成功');
            this.fetchProxyConfigs();
          } else {
            this.$message.error('代理配置删除失败: ' + response.data.msg);
          }
        } catch (error) {
          this.$message.error('代理配置删除出错: ' + error.message);
        }
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },

    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchProxyConfigs();
    }
  },
  mounted() {
    this.fetchProxyConfigs();
  }
};
</script>

<style scoped>
.app-container {
  padding: 20px;
}

.search-input {
  width: 200px;
}
</style>
